import { TableCellEmpty } from '@/components/custom';
import { getTitleEnumValue } from '@/functions';
import { TableCell } from '@/components/ui';
import { IHasCreator } from '@/interfaces';

export const DataTableBodyCellType = ({ creator }: IHasCreator) => (
  <TableCell className={'py-1 pe-0 w-24'}>
    {
      creator.type
        ? getTitleEnumValue('CreatorTypeEnum', creator.type)
        : <TableCellEmpty text='Non défini' />
    }
  </TableCell>
);

export default DataTableBodyCellType;
